import { COLEGIOS_NOTARIALES_URL, ROUTES } from '@/constants';

export const sidebarItems = [
	{
		label: 'Encuentra tu notario',
		children: [
			{ label: 'Buscador de notarios', to: ROUTES.INFORMACION_BUSCADOR_NOTARIOS },
			{ label: 'Libre elección de notarios', to: ROUTES.INFORMACION_LIBRE_ELECCION_NOTARIOS },
			{ label: 'Colegios Notariales', to: COLEGIOS_NOTARIALES_URL },
			{ label: 'Notarios de Guardia', to: ROUTES.INFORMACION_NOTARIOS_DE_GUARDIA },
		],
	},
	{ label: 'Academia de Opositores', to: ROUTES.INFORMACION_ACADEMIA_OPOSITORES },
	{ label: 'Corporación Notarial', to: ROUTES.INFORMACION_ORGANISMOS_INTERNACIONALES },
	{ label: 'Encuentra tu escritura', to: ROUTES.INFORMACION_ENCUENTRA_ESCRITURA },
	{ label: 'Nuevas actuaciones Notariales', to: ROUTES.INFORMACION_NUEVAS_ACTUACIONES_NOTARIALES },
	{ label: 'Enlaces de interés', to: ROUTES.INFORMACION_ENLACES_INTERES },
];
